import React, { useEffect, useState } from "react";
import { getFeatureType, show_proper_words } from "../../../utils/Constant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useIds } from "../../../hook/AdminContext";
import { useSnackbar } from "notistack";
import { s3baseUri } from "../../../config/config";
import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import { CircularProgress, useMediaQuery } from "@mui/material";
import { Carousel } from "react-bootstrap";
import CardCarousalSkeleton from "../../../components/loader/CradCarousalSkelator";
import {
  get_combune_category_blog_api,
  get_slider_blogs_api,
  get_categories_api,
} from "../../../DAL/categoryBlogs/ComineData";
import CommingSoon from "../../../components/recordNotFound/CommingSoon";
import { api_call_with_path_get } from "../../../DAL/general-apis/general-apis";
import { get_combined_podcast_data } from "../../../DAL/podcast/podcast";
import BlogCard from "./components/BlogCard";
import BlogSilder from "./components/BlogSilder";

export default function BlogFeaturePage() {
  const navigate = useNavigate();
  const { setBreadCrumb, userInfo } = useIds();
  const location = useLocation();
  const { source_slug, feature_slug } = useParams();
  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const [featureType, setFeatureType] = useState("");
  const [categories, setCategories] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [slider_blogs, set_Slider_blogs] = useState([]);

  // Categories pagination
  const [categoriesTotalPages, setCategoriesTotalPages] = useState(0);
  const [categoriesPageNumber, setCategoriesPageNumber] = useState(1);
  const [categoriesLoadMorePath, setCategoriesLoadMorePath] = useState("");
  const [isCategoriesLoadingMore, setIsCategoriesLoadingMore] = useState(false);
  // Categories pagination
  const [blogsTotalPages, setBlogsTotalPages] = useState(0);
  const [blogsPageNumber, setBlogsPageNumber] = useState(1);
  const [blogsLoadMorePath, setBlogsLoadMorePath] = useState("");
  const [isBlogsLoadingMore, setIsBlogsLoadingMore] = useState(false);

  // Slider blogs pagination
  const [sliderTotalPages, setSliderTotalPages] = useState(0);
  const [sliderPageNumber, setSliderPageNumber] = useState(1);
  const [sliderLoadMorePath, setSliderLoadMorePath] = useState("");
  const [isSliderLoadingMore, setIsSliderLoadingMore] = useState(false);

  const isMobile = useMediaQuery("(max-width:600px)", { noSsr: true });

  const fetchCategories = async (page = 1) => {
    setLoading(true);

    if (!source_slug || !feature_slug) {
      enqueueSnackbar("Missing Source or Feature", { variant: "error" });
      setLoading(false);
      return;
    }

    let response = null;
    response =
      featureType == "Podcasts"
        ? await get_combined_podcast_data(source_slug, feature_slug, page, 50)
        : await get_combune_category_blog_api(
            source_slug,
            feature_slug,
            page,
            50
          );

    if (response.code === 200) {
      // Handle slider blogs data
      if (response.blog_slider_data) {
        set_Slider_blogs(response.blog_slider_data.blogs);
        setSliderLoadMorePath(response.blog_slider_data.load_more_url);
        setSliderTotalPages(response.blog_slider_data.total_pages);
      } else {
        set_Slider_blogs([]);
        setSliderPageNumber(1);
        setSliderTotalPages(0);
      }

      // Handle categories data
      if (response.categories_data) {
        handleCategoriesResponse(response.categories_data);
      } else if (response.podcast_categories_data) {
        handleCategoriesResponse(response.podcast_categories_data);
      } else {
        setCategories([]);
        setCategoriesPageNumber(1);
        setCategoriesTotalPages(0);
      }

      // handle blogs
      if (response.blogs_data) {
        handleBlogsResponse(response.blogs_data);
      } else {
        setBlogs([]);
        setBlogsPageNumber(1);
        setBlogsTotalPages(0);
      }

      setLoading(false);
      setIsCategoriesLoadingMore(false);
      setIsSliderLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, {
        variant: "error",
      });
      setLoading(false);
      setIsCategoriesLoadingMore(false);
      setIsSliderLoadingMore(false);
    }
  };

  const handleCategoriesResponse = (resp, concat = false) => {
    let name = featureType == "Podcasts" ? "podcast_categories" : "categories";
    if (concat) {
      let new_array = categories.concat(resp[name]);
      setCategories(new_array);
      setCategoriesPageNumber((prev) => prev + 1);
    } else {
      setCategories(resp[name]);
      setCategoriesPageNumber(1);
    }
    setCategoriesLoadMorePath(resp.load_more_url);
    setCategoriesTotalPages(resp.total_pages);
  };
  const handleBlogsResponse = (resp, concat = false) => {
    if (concat) {
      let new_array = blogs.concat(resp.blogs);
      setBlogs(new_array);
      setBlogsPageNumber((prev) => prev + 1);
    } else {
      setBlogs(resp.blogs);
      setBlogsPageNumber(1);
    }
    setBlogsLoadMorePath(resp.load_more_url);
    setBlogsTotalPages(resp.total_pages);
  };
  const handleDetailAffiliations = (blog) => {
    let type = featureType == "Podcasts" ? "podcast-detail" : "blog-detail";
    navigate(`/${source_slug}/feature/${feature_slug}/${type}/${blog?.slug}`, {
      state: { blog: blog },
    });
  };

  const loadMoreCategories = async () => {
    if (
      isCategoriesLoadingMore ||
      categoriesPageNumber >= categoriesTotalPages
    ) {
      return;
    }
    setIsCategoriesLoadingMore(true);
    const resp = await api_call_with_path_get(categoriesLoadMorePath);
    if (resp.code === 200) {
      handleCategoriesResponse(resp, true);
    } else {
      enqueueSnackbar(resp.message, {
        variant: "error",
      });
    }
    setIsCategoriesLoadingMore(false);
  };
  const loadMoreBlogs = async () => {
    if (isBlogsLoadingMore || blogsPageNumber >= blogsTotalPages) {
      return;
    }
    setIsBlogsLoadingMore(true);
    const resp = await api_call_with_path_get(blogsLoadMorePath);
    if (resp.code === 200) {
      handleBlogsResponse(resp, true);
    } else {
      enqueueSnackbar(resp.message, {
        variant: "error",
      });
    }
    setIsBlogsLoadingMore(false);
  };

  const loadMoreSliderBlogs = async () => {
    if (isSliderLoadingMore || sliderPageNumber >= sliderTotalPages) return;
    setIsSliderLoadingMore(true);

    const response = await get_slider_blogs_api(
      source_slug,
      feature_slug,
      sliderPageNumber + 1,
      50
    );

    if (response.code === 200) {
      let new_array = slider_blogs.concat(response.blogs);
      set_Slider_blogs(new_array);
      setSliderPageNumber((prev) => prev + 1);
      setSliderLoadMorePath(response.load_more_url);
      setSliderTotalPages(response.total_pages);
    }

    setIsSliderLoadingMore(false);
  };

  const handleNavigateDetail = (value) => {
    navigate(`/${source_slug}/feature/${feature_slug}/${value?.title_slug}`);
  };

  useEffect(() => {
    if (source_slug && feature_slug) {
      setLoading(true);
      setCategories([]);
      set_Slider_blogs([]);
      setCategoriesPageNumber(1);
      setSliderPageNumber(1);
      setCategoriesTotalPages(0);
      setSliderTotalPages(0);
      setCategoriesLoadMorePath("");
      setSliderLoadMorePath("");
      setIsCategoriesLoadingMore(false);
      setIsSliderLoadingMore(false);
    }
  }, [source_slug, feature_slug]);

  useEffect(() => {
    setFeatureType(
      getFeatureType(source_slug, feature_slug, userInfo?.navbar || [])
    );
  }, [source_slug, feature_slug, userInfo]);

  useEffect(() => {
    if (featureType) {
      fetchCategories();
    }
  }, [source_slug, feature_slug, featureType]);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(source_slug)}`,
        path: `/home`,
        active: false,
      },
      {
        name: `${feature_slug}`,
        path: `/${source_slug}/feature/${feature_slug}`,
        active: true,
      },
    ]);
  }, [source_slug, feature_slug]);

  if (loading) {
    return <CardCarousalSkeleton />;
  }

  return (
    <div className="container-fluid blogs-section">
      {slider_blogs?.length > 0 && (
        <div className="d-flex mt-3">
          <div className="heading-main">
            <h2>
              {show_proper_words(feature_slug)} {featureType}
            </h2>
          </div>
        </div>
      )}

      {slider_blogs?.length > 0 ? (
        <div className="overview-slider">
          <BlogSilder
            slider_blogs={slider_blogs}
            handleDetails={handleDetailAffiliations}
          />
        </div>
      ) : (
        // <RecordNotFound title="No Blogs " />
        ""
      )}

      <div className="row">
        {blogs && blogs.length == 0 && categories && categories.length == 0 && (
          <div className="col-12">
            <CommingSoon />
          </div>
        )}

        {categories && categories.length > 0 && (
          <>
            <div className="col-12 mb-1 mt-3">
              <h4>{show_proper_words(feature_slug)} categories</h4>
            </div>
            {categories.map((topic, index) => (
              <div
                key={index}
                className="col-12 col-sm-6 col-md-6 col-lg-3 mt-3"
              >
                <div
                  className="card-1 h-100 cursor-pointer"
                  onClick={() => handleNavigateDetail(topic)}
                >
                  <img
                    onClick={() => handleNavigateDetail(topic)}
                    style={{ cursor: "pointer" }}
                    src={s3baseUri + topic?.image[0]?.thumbnail_2}
                    alt="logo"
                    className="card-img-top-interview p-0 w-100"
                  />
                  <div className="card-body card-content-partners">
                    <h5
                      onClick={() => handleNavigateDetail(topic)}
                      className="card-title"
                    >
                      {topic.title}
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}

        {/* {categoriesPageNumber < categoriesTotalPages && (
              <div className="col-12 text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={loadMoreCategories}
                  disabled={isCategoriesLoadingMore}
                >
                  {isCategoriesLoadingMore ? (
                    <>
                      <CircularProgress
                        color="inherit"
                        size="1rem"
                        className="me-2"
                      />
                      Loading...
                    </>
                  ) : (
                    "Load More Categories"
                  )}
                </button>
              </div>
            )} */}

        {blogs && blogs.length > 0 && (
          <>
            <div className="heading-main-hr mb-1 mt-3">
              <h2>
                {show_proper_words(feature_slug)} {featureType}
              </h2>
            </div>
            {blogs.map((blog, index) => (
              <BlogCard
                item={blog}
                index={index}
                handleDeatilAffilations={handleDetailAffiliations}
              />
            ))}
            {blogsPageNumber < blogsTotalPages && (
              <div className="col-12 text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={loadMoreBlogs}
                  disabled={isBlogsLoadingMore}
                >
                  {isBlogsLoadingMore ? (
                    <>
                      <CircularProgress
                        color="inherit"
                        size="1rem"
                        className="me-2"
                      />
                      Loading...
                    </>
                  ) : (
                    "Load More Blogs"
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
